import type {DependenciesManager, Pointer, DependenciesBuilder} from '@wix/document-services-types'
import type {ExternalsHandler} from '../../constants'
import type {DetailedValue, ExtendedRefInfo} from '@wix/import-export-utils'
import type {DalValue} from '@wix/document-manager-core'
import _ from 'lodash'

export const defaultRefsHandler: ExternalsHandler = {
    pack: (ref: DetailedValue, dependenciesBuilder: DependenciesBuilder, refPointer: Pointer) =>
        dependenciesBuilder.references.addNonOwnedRef(refPointer.id, refPointer.type),
    unpack: (
        ref: DetailedValue,
        dependenciesManager: DependenciesManager,
        refFieldInfo: ExtendedRefInfo,
        item: DalValue
    ) => {
        const newId = dependenciesManager.references.getNewItemRef(ref.value, refFieldInfo)
        _.set(item, ref.path, newId)
    }
}
